class AddParticipantModalController {
    /*@ngInject*/
    constructor($timeout, modalService, meetingService) {
        this.$timeout = $timeout;
        this.modalService = modalService;
        this.meetingService = meetingService;
        // this.scheduleId = this.resolve.scheduleId;
        // this.jobMatchId = this.resolve.jobMatchId;
        // this.jobMatchObject = this.resolve.jobMatchObject;
        // this.scheduleObject = this.resolve.scheduleObject;
        // this.scheduleType = this.resolve.scheduleType;
        // // this.corpVendorInfo = this.resolve.corpVendorInfo;
        // this.waitingParticipants = this.resolve.waitingParticipants;
        // this.joiningParticipant = this.resolve.joiningParticipant;
        // this.externalMeetingCallId = this.resolve.externalMeetingCallId;
        // //feedback edit enable
        // this.feedbackDetails = this.resolve.feedbackDetails;
        // this.actionType = this.resolve.actionType;
        // //primary host change
        // this.primaryHostChangeDetails = this.resolve.primaryHostChangeDetails;
    }
    $onInit() {
        this.scheduleId = this.resolve.scheduleId;
        this.jobMatchId = this.resolve.jobMatchId;
        this.jobMatchObject = this.resolve.jobMatchObject;
        this.scheduleObject = this.resolve.scheduleObject;
        this.scheduleType = this.resolve.scheduleType;
        // this.corpVendorInfo = this.resolve.corpVendorInfo;
        this.waitingParticipants = this.resolve.waitingParticipants;
        this.joiningParticipant = this.resolve.joiningParticipant;
        this.externalMeetingCallId = this.resolve.externalMeetingCallId;
        //feedback edit enable
        this.feedbackDetails = this.resolve.feedbackDetails;
        this.actionType = this.resolve.actionType;
        //primary host change
        this.primaryHostChangeDetails = this.resolve.primaryHostChangeDetails;
        if (this.actionType == "inviteUsers") {
            this.title = "Invite Users";
        }
        else if (this.actionType == "waitingParticipants") {
            this.title = "Participants Waiting";
            for (let participant of this.waitingParticipants) {
                participant.isApproved = true;
            }
            if (this.waitingParticipants.length == 1) {
                this.joiningParticipant = this.waitingParticipants[0];
                this.actionType = "joiningParticipant";
            }
        }
        else if (this.actionType == "joiningParticipant") {
            this.title = "Approval to join meeting";
            this.joiningParticipant.isApproved = true;
        }
        else if (this.actionType == "enableFeedbackEdit") {
            this.title = "Leave meeting";
            this.usersToEditFeedback = this.feedbackDetails.usersToEditFeedback;
            this.externalMeetingCallId = this.feedbackDetails.externalMeetingCallId;
            this.scheduleId = this.feedbackDetails.scheduleId;
            this.readOnly = false;
            this.loadingUsers = true;
            this.setFeedbackEnabledAttendeeId();
        }
        else if (this.actionType == "primaryHostChange") {
            this.title = "Assign Primary Host";
            this.usersToEditFeedback = this.primaryHostChangeDetails.usersToEditFeedback;
            this.externalMeetingCallId = this.primaryHostChangeDetails.externalMeetingCallId;
            this.scheduleId = this.primaryHostChangeDetails.meetingScheduleId;
            this.readOnly = false;
            this.loadingUsers = true;
            this.setPrimaryHostAttendeeId();
        }
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    setFeedbackEnabledAttendeeId() {
        this.loadingUsers = true;
        this.meetingService.getFeedbackEditEnabledAttendeeId(this.externalMeetingCallId, (data) => {
            this.enableEditForAttendeeId = data.attendeeId;
            this.previouslyEnabledEditForAttendeeId = data.attendeeId;
            this._setHosts();
        }, error => {
            //do nothing
        });
    }
    setPrimaryHostAttendeeId() {
        this.loadingUsers = true;
        this.meetingService.getPrimaryHostAttendeeId(this.externalMeetingCallId, data => {
            this.enableEditForAttendeeId = data.attendeeId;
            this.previouslyEnabledEditForAttendeeId = data.attendeeId;
            this._setHosts();
        }, error => {
            //do nothing
        });
    }
    _setHosts() {
        this.loadingUsers = true;
        if (this.usersToEditFeedback && this.usersToEditFeedback.length > 0) {
            this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
            if (this.enabledEditForUser !== undefined) {
                this.readOnly = this.enabledEditForUser.displayName !== 'You';
                this.previousEnableEditFor = angular.copy(this.enabledEditForUser);
            }
        }
        this.$timeout(() => {
            this.loadingUsers = false;
        }, 2000);
    }
    onUserWhoCanEditFeedbackChange() {
        this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
    }
    onPrimaryHostChange() {
        this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
    }
    confirmWhoCanEditFeedbackChangeAndLeave() {
        let message = `Only '${this.enabledEditForUser.displayName}' will be allowed to edit the feedback.<br> Do you want to continue?`;
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._approveUserToEditFeedback(true);
                }
                else {
                    this._selectPreviousUser();
                }
            }
        });
    }
    confirmPrimaryHostChangeAndLeave() {
        let message = `'${this.enabledEditForUser.displayName}' will be made the primary host.<br> Do you want to continue?`;
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._approverUserAsPrimaryHost();
                }
                else {
                    this._selectPreviousUser();
                }
            }
        });
    }
    _selectPreviousUser() {
        this.loadingUsers = true;
        this.enabledEditForUser = angular.copy(this.previousEnableEditFor);
        if (this.previousEnableEditFor !== null) {
            this.enableEditForAttendeeId = this.previousEnableEditFor.attendeeId;
        }
        else {
            this.enableEditForAttendeeId = this.previouslyEnabledEditForAttendeeId;
            this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        this.$timeout(() => {
            this.loadingUsers = false;
        }, 1000);
    }
    _approveUserToEditFeedback(isApproved, requesterAttendeeId) {
        this.loadingUsers = true;
        let currentUserAttendeeId = this.usersToEditFeedback.find(user => user.displayName == 'You').attendeeId;
        let enableEditForAttendeeId = isApproved ? this.enableEditForAttendeeId : requesterAttendeeId;
        let attendeeIds = this.usersToEditFeedback.map(attendee => attendee.attendeeId);
        let approvalDetails = {
            attendeeId: enableEditForAttendeeId,
            approverId: currentUserAttendeeId,
            meetingScheduleId: this.scheduleId,
            externalMeetingCallId: this.externalMeetingCallId,
            attendeeIds: attendeeIds,
            approved: isApproved
        };
        this.meetingService.giveFeedbackEditApproval(approvalDetails, (data) => {
            if (isApproved) {
                this.previousEnableEditFor = angular.copy(this.enabledEditForUser);
            }
            this.$timeout(() => {
                this.leaveMeeting();
            }, 2000);
        }, error => {
            this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
        });
    }
    _approverUserAsPrimaryHost() {
        this.loadingUsers = true;
        let currentUserAttendeeId = this.usersToEditFeedback.find(user => user.displayName == 'You').attendeeId;
        this.primaryHostChangeDetails.newHostAttendeeId = this.enableEditForAttendeeId;
        this.meetingService.makeUserPrimaryHost(this.primaryHostChangeDetails, (data) => {
            this.$timeout(() => {
                this.leaveMeeting();
            }, 2000);
        }, error => {
            this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
        });
    }
    leaveMeeting() {
        this.callbackObject.callbackType = 'leaveMeeting';
        this.modalInstance.close(this.callbackObject);
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
    addParticipant() {
        this.callbackObject.callbackType = 'add';
        this.callbackObject.entity = angular.copy(this.participant);
        this.modalInstance.close(this.callbackObject);
    }
    allow() {
        const selectedParticipants = this.waitingParticipants.filter(participant => participant.isApproved);
        if (selectedParticipants.length == 0) {
            this.displayNoSelectionMessage = true;
        }
        else {
            let entity = {
                participantDetails: this.waitingParticipants,
                externalMeetingCallId: this.externalMeetingCallId
            };
            this.callbackObject.callbackType = 'addParticipants';
            this.callbackObject.entity = angular.copy(entity);
            this.modalInstance.close(this.callbackObject);
        }
    }
    validateParticipant() {
        this.displayNoSelectionMessage = this.waitingParticipants.filter(participant => participant.isApproved).length == 0;
    }
    allowJoiningParticipant() {
        let entity = {
            participantDetails: [this.joiningParticipant],
            externalMeetingCallId: this.externalMeetingCallId
        };
        this.callbackObject.callbackType = 'addParticipants';
        this.callbackObject.entity = angular.copy(entity);
        this.modalInstance.close(this.callbackObject);
    }
    disApproveParticipants() {
        if (this.actionType == "waitingParticipants") {
            for (let participant of this.waitingParticipants) {
                participant.isApproved = false;
            }
            let entity = {
                participantDetails: this.waitingParticipants,
                externalMeetingCallId: this.externalMeetingCallId
            };
            this.callbackObject.entity = angular.copy(entity);
        }
        else if (this.actionType == "joiningParticipant") {
            this.joiningParticipant.isApproved = false;
            let entity = {
                participantDetails: [this.joiningParticipant],
                externalMeetingCallId: this.externalMeetingCallId
            };
            this.callbackObject.entity = angular.copy(entity);
        }
        this.callbackObject.callbackType = 'disApproveParticipants';
        this.modalInstance.close(this.callbackObject);
    }
}
AddParticipantModalController.$inject = ['$timeout', 'modalService', 'meetingService'];
import * as TEMPLATE from 'raw-loader!./add-participant-modal.html';
export const AddParticipantModalComponent = {
    selector: 'addParticipantModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: AddParticipantModalController,
        template: TEMPLATE.default,
    }
};
//# sourceMappingURL=add-participant-modal.component.js.map